import { typography } from '@/design-system/tokens/typography';

interface SubTitleProps {
  title: string;
  className?: string;
  textclassName?: string;
  fontSize?: string;
}

const SubTitle = ({
  title,
  className = '',
  textclassName = '',
  fontSize,
}: SubTitleProps) => {
  return (
    <div className={`${className}`}>
      <h6
        className={`font-semibold text-black leading-[1.375rem] capitalize ${textclassName}`}
        style={{
          fontSize: fontSize || typography.size.sm, // Default to 14px, can be overridden
          fontFamily: typography.fonts.primary,
        }}
      >
        {title}
      </h6>
    </div>
  );
};

export default SubTitle;
